import React from 'react';
import WindowSize from 'src/context/WindowSize';
import styles from './Layout.module.scss';

const Fullscreen = ({ children }) => {
  return (
    <WindowSize>
      <div className={`${styles.wrapper} ${styles.fullscreen}`}>
        <main role="main" tabIndex="-1" id="main-content" className={styles.FullscreenContent}>
          {children}
        </main>
      </div>
    </WindowSize>
  );
};

export default Fullscreen;
